module.exports = __webpack_public_path__ + "img/check-available.5724f215.svg";